// @ts-nocheck
import React from "react";
import { Container } from "@mui/material";

import StylesProvider from "./../components/theme/stylesprovider";
import { CustomThemeProvider } from "./../components/theme";
import "./../index.css";

type EntryWrapperProps = {
  children?: React.ReactNode;
  generateClassName?: Function | undefined;
};

const EntryWrapper = (props: EntryWrapperProps): JSX.Element => {
  const { children, generateClassName } = props;
  return (
    <React.StrictMode>
      <CustomThemeProvider>
        <StylesProvider generateClassName={generateClassName}>
          <Container className="sa_content_filtering" disableGutters>
            {children}
          </Container>
        </StylesProvider>
      </CustomThemeProvider>
    </React.StrictMode>
  );
};

export default EntryWrapper;
